import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/data/site";
import { SectionHeading } from "@/components/pp/Shared";

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 md:py-32" data-testid="faq">
      <div className="pp-container grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <SectionHeading overline="FAQ" title="Questions, Answered" testid="faq-heading" />
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display uppercase text-lg md:text-xl text-white hover:text-[#f59e0b] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
